module.exports = function() {
  return new Worker(__webpack_public_path__ + "e08ba85aa6b7bd841170.worker.js");
};